<template>
  <div class="container">
    <div class="logo-box">
      <img :src="Logo" class="logo" />
    </div>
    <div class="login-form">
      <div class="form-group">
        <p class="welcome">欢迎登录</p>
        <p class="welcome-msg">请使用本人账号密码登录</p>
        <Form
          ref="uInfo"
          label-postion="top"
          :model="uInfo"
          :rules="ruleValidate"
          @keydown.enter.native="toLogin"
        >
          <form-item prop="phone">
            <span class="title">账号</span>
            <base-input
              v-model="uInfo.phone"
              class="field"
              placeholder
              :maxlength="60"
              :disabled="loading"
            ></base-input>
          </form-item>
          <form-item prop="password">
            <span class="title">密码</span>
            <base-input
              :disabled="loading"
              v-model="uInfo.password"
              type="password"
              class="field"
              placeholder
              :maxlength="60"
            ></base-input>
          </form-item>
        </Form>
        <Button
          class="toLogin"
          @click="toLogin"
          type="primary"
          :disabled="loading"
          >登录</Button
        >
      </div>
    </div>
    <p class="copyright">
      <span class="cr-icon">©</span>Copyright {{ currentYear }}
      {{ companyName }} {{ icpNumber }}
    </p>
  </div>
</template>
<script>
import Logo from "./images/logo.png";
import { mapActions } from "vuex";
import md5 from "md5";

export default {
  data() {
    return {
      Logo: Logo,
      uInfo: {
        phone: "",
        password: "",
      },
      ruleValidate: {
        phone: [
          {
            required: true,
            message: "账号必填",
          },
        ],
        password: [
          {
            required: true,
            message: "密码必填",
          },
        ],
      },
      loading: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    companyName() {
      return process.env.VUE_APP_COMPANY_NAME;
    },
    icpNumber() {
      return process.env.VUE_APP_ICP_NUMBER;
    },
  },
  methods: {
    ...mapActions(["handleLogin"]),
    toLogin() {
      this.$refs.uInfo.validate((valid) => {
        if (valid) {
          this.handleSubmit({
            phone: this.uInfo.phone,
            password: md5(this.uInfo.password),
            loginType: 0,
          });
        }
      });
    },
    handleSubmit({ phone, password }) {
      this.loading = true;

      this.handleLogin({ phone, password })
        .then(() => {
          // 跳转到首页
          this.$router.push("/");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .logo-box {
    position: relative;
    height: 80px;
    .logo {
      position: absolute;
      top: 50%;
      left: 100px;
      transform: translateY(-50%);
      height: 37px;
      width: auto;
    }
  }
  .copyright {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    .cr-icon {
      font-size: 18px;
      margin-right: 5px;
      padding-top: 2px;
    }
  }
}
.login-form {
  height: calc(~"100% - 130px");
  width: 100%;
  background: url("./images/login-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;

  .form {
    &-group {
      position: absolute;
      text-align: left;
      box-sizing: border-box;
      padding: 40px 42px;
      width: 335px;
      height: 340px;
      font-size: 14px;
      right: 15%;
      top: 50%;
      border-radius: 18px;
      transform: translateY(-50%);
      background-color: rgba(255, 255, 255, 0.8);
      .welcome {
        font-weight: 700;
        font-size: 20px;
        &-msg {
          line-height: 32px;
          margin-bottom: 20px;
        }
      }
      .title {
        display: inline-block;
        vertical-align: top;
        width: 50px;
        height: 30px;
        line-height: 30px;
        color: #515a6e;
        background-color: #f7f5f6;
        border-radius: 5px 0 0 5px;
        text-align: center;
      }

      .field {
        display: inline-block;
        vertical-align: top;
        width: 200px;
        height: 30px;
        line-height: 30px;
        color: #515a6e;
        border: 0;
        border-radius: 0 5px 5px 0;
        background-color: #f7f5f6;

        &:focus {
          outline: 0;
        }
      }

      .remember {
        display: inline-block;
        vertical-align: middle;
        color: #197de5;
        margin-left: 5px;
        font-size: 12px;
      }

      .checkbox {
        vertical-align: middle;
      }

      .toLogin {
        width: 100%;
        height: 36px;
        border-radius: 27px;
        color: #fff;
        border: 0;
        margin-top: 30px;
      }
    }
  }
}
</style>
